import * as dotProp from 'dot-prop-immutable';
import { Action } from 'typescript-fsa';

import { createReducer } from '@topconagriculture/frontend-utils';

import { Role } from '../../../core/api/common/common.types';
import { getRolesList } from './common.actions';

export type CommonState = {
  readonly roles: Role[];
};

export const initialState: CommonState = {
  roles: [],
};

const commonReducer = createReducer(initialState, {
  [getRolesList.done.type]: (state: CommonState, action: Action<{ result: Role[] }>) => {
    return dotProp.set(state, 'roles', action.payload.result);
  },
});

export default commonReducer;
